import { FCM_PLATFORM_CHANNEL } from "@acme/constants";

export const PLATFORM_FCM_EVENT_NAME = "platform-fcm-event";
export const FCM_DISPLAY_NOTIFICATION_MESSAGE_TYPE = "fcm-display-notification";

export interface PlatformFcmEventDetail {
  channel?: string;
  type?: string;
  dbUpdated?: string;
  timestamp?: string;
  jobsWritten?: string;
  title?: string;
  body?: string;
}

export function isPlatformFcmPayload(data: Record<string, string | undefined> | undefined): boolean {
  return data?.channel === FCM_PLATFORM_CHANNEL;
}

export function dispatchPlatformFcmEvent(detail: PlatformFcmEventDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PLATFORM_FCM_EVENT_NAME, { detail }));
}
